// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__4vXoJ","name":"ConsentHeader_name__3ZqDW","birthday":"ConsentHeader_birthday__2AWQu","skeleton":"ConsentHeader_skeleton__3KZaw"};